import {
  FilterMode,
  EsignatureDocument_OrderBy,
  EsignatureDocument,
  SortOrder,
  EsignatureDocument_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const esignatureDocumentService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.esignatureDocumentOne({ id });
    return result.esignatureDocumentOne as EsignatureDocument;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EsignatureDocument_OrderBy[] | null = null,
    filter: EsignatureDocument_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EsignatureDocument_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.esignatureDocumentListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.esignatureDocumentListWithOffset
    ) as EsignatureDocument[];
    return { list, orderBy };
  },
};
